import type { ClienteSaldo } from '@aid/shared';
import { SaldosTable } from './SaldosTable';
import { DashboardCard } from '../../../components/DashboardCard';
import { useT } from '../../../locales';

interface TopDeudoresCardProps {
  data: ClienteSaldo[];
}

export function TopDeudoresCard({ data }: TopDeudoresCardProps) {
  const t = useT();

  return (
    <DashboardCard
      title={t('dashboard.deudoresTitulo')}
      subtitle={t('dashboard.deudoresTituloDesc')}
      bodyStyle={{ padding: '4px 4px 8px' }}
    >
      <SaldosTable data={data} />
    </DashboardCard>
  );
}
